/**
 * Renders the main news hero on the home page, containing news item components
 * WARNING: Uses temporary dummy data
 * On home page and club page
 */
import React from "react";
import NewsItem from "./NewsItem";
import { useQuery } from "@tanstack/react-query";
import { useState, useEffect } from "react";
import { processEpochMini } from "../utils/time";

// Fetch the latest news using react-query

const NewsHero = ({ data, small, club, title }) => {

  return data && data.length > 0 ? (
      <>
        {title !== undefined ? <h2 className="leading-tight text-left text-2xl font-semibold mb-2">{title}</h2> : null}
      <div className="flex flex-col sm:flex-row items-center justify-center sm:mx-0 sm:my-1 w-full sm:px-4 xxs:px-4 px-2">
        {data.map((news, index) => {
          return  <NewsItem
              author={data[0].author_name}
              filename={news.img}
              time={processEpochMini(news.date)}
              title={news.title}
              newsId={news.id}
              last={index === (data.length - 1)}
              isSmall={small}
              url_override={news.url}
          />
        })}
      </div>
      </>
  ) : null;
};
export default NewsHero;
